import {getFullUrl} from '@/libs/api/api'
export default {
    name: 'ShortUrl',
    async beforeCreate() {
        try {
            if (this.$route && this.$route.params && this.$route.params.id) {
                fetch('https://api.ipify.org?format=json')
                .then(x => x.json())
                .then( async({ ip }) => {
                    let response = await getFullUrl(this.$route.params.id, {'user-ip': ip})
                    window.location.href=response.redirect_url
                });
            }
        } catch (error) {
            this.$router.push({name: 'error-page'})
        }
    },
}